import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-invited-orgs-stats',
  templateUrl: './invited-orgs-stats.component.html',
  styleUrls: ['./invited-orgs-stats.component.css']
})
export class InvitedOrgsStatsComponent implements OnInit {
  loading = false;
  search = '';

  summary: any = null;
  displayedColumns: string[] = [
    'srNo',
    'org_name',
    'primary_contact_email',
    'invitedAt',
    'invitedRole',
    'onboarding',
    'subscription'
  ];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private readonly apiService: ApiService,
    private readonly toastr: ToastrService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.fetch();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  fetch(): void {
    this.loading = true;
    this.apiService.getInvitedOrgStats().subscribe({
      next: (res: any) => {
        this.summary = res?.summary || null;
        this.dataSource.data = res?.data || [];
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.toastr.error(
          err?.error?.message || this.translate.instant('invitedOrgs.loadError')
        );
      }
    });
  }

  applyFilter(): void {
    const v = (this.search || '').trim().toLowerCase();
    this.dataSource.filter = v;
  }

  onboardingLabel(row: any): string {
    if (row?.onboardingCompleted) {
      return this.translate.instant('invitedOrgs.onboardingCompleted');
    }
    if (row?.onboardingRequired) {
      return this.translate.instant('invitedOrgs.onboardingPending');
    }
    return this.translate.instant('invitedOrgs.onboardingUnknown');
  }
}

